import styled from 'styled-components';

import { Button, Text } from '@gympass/yoga';

export const Container = styled.div`
  display: grid;
  gap: ${({ theme }) => theme.yoga.spacing.xxsmall}px;
  justify-items: center;
`;

export const AnswerContent = styled.iframe.attrs(() => ({
  frameBorder: 0,
}))`
  margin-bottom: 36px;
  height: calc(100vh - 400px);
  width: ${({ theme }) => theme.yoga.sizes.assessmentAnswersModalWidth}px;
`;

export const ModalTitle = styled(Text.H5)`
  margin-bottom: ${({ theme }) => theme.yoga.spacing.xlarge}px;
`;

export const ModalButton = styled(Button)`
  border-radius: ${({ theme }) => theme.yoga.radii.small}px;
`;
